import { ReactNode } from "react";
import GameLapStats, { lapData } from "./gameLapStat.tsx";
import { GameStats } from "../lib/definitions.ts";
import CarStat from "./gameCarStat.tsx";

type carTotal = {
    totTime : Array<number>
    totBonus : Array<number>
    totDMG : Array<number>
    totNitros : Array<number>
    totalToken: Array<number>
    raceBonus: Array<number>
}


type GameStatsProp = {
   stats: Array<GameStats> | null
   totalBonus: number
}

const GameStatsTable = (props: GameStatsProp): ReactNode => {

    const stats = props.stats;

    if(stats === null)
        return (<div></div>);

    console.log('setGameStats :' + stats);


 

    const lapTxt:Array<lapData>= [];
    const carTotal: carTotal = {
        totTime : [],
        totBonus : [],
        totDMG : [],
        totNitros : [],
        totalToken: [],
        raceBonus: []
    }

    for(let cars =0; cars < stats.length;cars++){
        carTotal.totTime[cars] = 0;
        carTotal.totBonus[cars] = 0;
         carTotal.totDMG[cars] = 0;
         carTotal.totNitros[cars] = 0;
         carTotal.totalToken[cars] = 0;
         carTotal.raceBonus[cars] = props.totalBonus *  stats[cars].laps.length
    }

    

    for(let laps =0; laps < 3;laps++){

        lapTxt[laps] = {bonustxt : [],timetxt : [],txtnitros : [],txtdmg : [],color:[]};

        for(let cars =0; cars < stats.length;cars++){

            const carstat = stats[cars];

            if(laps >= carstat.laps.length){
                lapTxt[laps].bonustxt[cars]=  '---';
                lapTxt[laps].timetxt [cars]= '---';
                lapTxt[laps].txtnitros [cars]= '---';
                lapTxt[laps].txtdmg [cars]= '---';
                lapTxt[laps].color [cars]= carstat.color;
                carTotal.totTime[cars] += carstat.lapTime;
                continue;
            }

            const  carlap = carstat.laps[laps];

            lapTxt[laps].bonustxt[cars] = carlap.bonus.toString() +'/' + props.totalBonus.toString();
            lapTxt[laps].timetxt[cars] = carlap.time.toString();
            lapTxt[laps].txtnitros[cars] = carlap.usedNitros.toFixed(0);
            lapTxt[laps].txtdmg[cars] = carlap.dmg.toFixed(2);
            lapTxt[laps].color[cars] = carstat.color;
            
            carTotal.totTime[cars] += parseFloat(carlap.time.toString());
            carTotal.totBonus[cars] += carlap.bonus;
            carTotal.totDMG[cars] += carlap.dmg;
            carTotal.totNitros[cars] += carlap.usedNitros;
        }

       
        /*
        const lapidx = laps + 1;
        $('#lap'+lapidx+'-time').htsml(timetxt);
        $('#lap'+lapidx+'-bonus').html(bonustxt);
        $('#lap'+lapidx+'-dmg').html(txtdmg);
        $('#lap'+lapidx+'-nitro').html(txtnitros);
        */
        /*
        if(nLaps>=laps)
            $('#lap'+laps+'-row > td').each(function (index, value){ $(value).addClass('finished-lap'); });
        */
    }

    const carsidx = [0,1,2,3];
    carsidx.sort(function(a, b) {
        
        if(carTotal.totTime[a]<carTotal.totTime[b])
            return -1;

        if(carTotal.totTime[a]>carTotal.totTime[b])
            return 1;

        return 0;
    });

    for(let cars =0; cars < stats.length;cars++) {
        carTotal.totalToken[cars] = carTotal.totBonus[cars] * stats[cars].multiplier;
    }

    const totRaceBonus = carTotal.totBonus.map( (txt , idx) => <CarStat key={"total-bonus-"+carsidx[idx]} carid={carsidx[idx]} infos = {carTotal.totBonus[carsidx[idx]].toFixed(1)}  color = {stats[carsidx[idx]].color} />);
    const totRaceTime = carTotal.totTime.map( (txt , idx) => <CarStat key={"total-time-"+carsidx[idx]} carid={carsidx[idx]} infos = {carTotal.totTime[carsidx[idx]].toFixed(1)}  color = {stats[carsidx[idx]].color}/>);
    const totRaceDmg = carTotal.totDMG.map( (txt , idx) => <CarStat key={"total-dmg-"+carsidx[idx]} carid={carsidx[idx]} infos = {carTotal.totDMG[carsidx[idx]].toFixed(2)}  color = {stats[carsidx[idx]].color} />);
    const totRaceNitros = carTotal.totNitros.map( (txt , idx) => <CarStat key={"total-nitro-"+carsidx[idx]} carid={carsidx[idx]} infos = {carTotal.totNitros[carsidx[idx]].toFixed(0)} color = {stats[carsidx[idx]].color} />);

    return (  
        <div id="end-race">
            <table className="table">
            <thead>
                <tr><th>lap</th><th>bonus</th><th>time</th><th>dmg</th><th>nitro</th></tr>
            </thead>
            <tbody>

                <GameLapStats lapid = "1" laps = {lapTxt[0]} carsidx={carsidx}></GameLapStats>
                <GameLapStats lapid = "2" laps = {lapTxt[1]} carsidx={carsidx} ></GameLapStats>
                <GameLapStats lapid = "3" laps = {lapTxt[2]} carsidx={carsidx} ></GameLapStats>

                <tr>
                    <td> #total</td>
                    <td id="total-bonus">{totRaceBonus}</td>
                    <td id="total-time">{totRaceTime}</td>
                    <td id="total-dmg">{totRaceDmg}</td>
                    <td id="total-nitro">{totRaceNitros}</td>
                </tr>

            </tbody>
        </table>
    </div>)
       

}

export default GameStatsTable;